export default {"src":"/_next/static/media/shopping_cart.108d476f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};